'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalMountPoint = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _visualStack = require('@cjdev/visual-stack');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Backdrop = _visualStack.Modal.Backdrop;

var ModalMountPointPure = function ModalMountPointPure(_ref) {
  var Component = _ref.component,
      props = _ref.props;
  return Component ? _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(Component, props),
    _react2.default.createElement(Backdrop, null)
  ) : _react2.default.createElement('div', null);
};

var ModalMountPoint = exports.ModalMountPoint = (0, _reactRedux.connect)(function (state) {
  return {
    component: state.visualStack.modal.component,
    props: state.visualStack.modal.props
  };
})(ModalMountPointPure);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cjdev/visual-stack-redux/lib/components/Modal.js
// module id = 862
// module chunks = 0